enum OrderMenuPreOrderType {
  PreOrder,
  NoPreOrder
}

export default OrderMenuPreOrderType
